import { GetDefaultServiceAppointmentData } from './defaultServiceAppointmentData';
export default {
    deleteAppointmentModal: {
        isOpen: false,
        deletingId: null,
    },
    editAppointmentModal: {
        isOpen: false,
        editingId: null,
        ticket: null,
        data: GetDefaultServiceAppointmentData(),
        errors: {},
        autocomplete: {
            projectsSearchTerm: '',
            ordersSearchTerm: '',
            projects: [],
            orders: [],
            types: [],
            technicians: [],
            expectedDurations: [],
            statuses: [],
            responsiblePartyTypes: [],
        },
        actionWithReason: {
            isOpen: false,
            action: null,
            reason: '',
            errors: {},
        },
        newlyUploadedFiles: [],
        baseRoute: null,
        isFindTimeOpen: false,
    },
    appointmentList: {
        refreshList: false,
        filtersOpen: false,
        filterData: {
            assignees: [],
            types: [],
            statuses: [],
            report_statuses: [],
        },
        filters: {
            per_page: 10,
            only_my: false,
            filter: '',
            assignees: [],
            types: [],
            statuses: [],
            report_statuses: [],
        },
    },
    relatedServiceAppointments: [],
};
